export interface StatTileProps {
  label: string;
  value: string;
}

/** Exactly one hero figure per view is the rule; this renders any one stat tile in that family. */
export function StatTile({ label, value }: StatTileProps) {
  return (
    <div className="stat-tile">
      <div className="stat-tile__label">{label}</div>
      <div className="stat-tile__value numeric">{value}</div>
    </div>
  );
}
